export enum FristenGrund {
  ARBEITSVERTRAG_ENDE = 'ARBEITSVERTRAG_ENDE',
  PROBEZEIT_ENDE = 'PROBEZEIT_ENDE',
  ARBEITSERLAUBNIS_ENDE = 'ARBEITSERLAUBNIS_ENDE',
  AUFENTHALTSERLAUBNIS_ENDE = 'AUFENTHALTSERLAUBNIS_ENDE',
  SEMESTERBESCHEINIGUNG_ENDE = 'SEMESTERBESCHEINIGUNG_ENDE',
  ANDERER = 'ANDERER',
}
